/* eslint-disable prettier/prettier */
import Component from '../abstracts/Component';
import { isMobile, MobileBreakpoint } from '../utils/MobileUtils';
import slick from 'slick-carousel';

export default class HeroComponent extends Component {
  get SELECTORS() {
    return {
      hero: '.c-hero',
      heroSlider: '#hero-slider',
      hero2Item: '#hero-2-item',
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.hero = document.querySelectorAll(this.SELECTORS.hero)
    this.heroSlider = $(this.SELECTORS.heroSlider)
    this.hero2Item = $(this.SELECTORS.hero2Item)
  }

  bindEvents() {
    console.warn('bindEvents HeroComponent')

    if (this.heroSlider) this.mountSlider();
    if (this.hero2Item) this.mount2Item();
    if (this.hero) this.mountHeroElements()
  }

  mountSlider() {
    const $progressBar = $('.progress');

    this.heroSlider.on('init', function(event, slick ) {
      let calc = 100 / slick.slideCount;
      $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );

      if( slick.slideCount < 2) {
        $progressBar
        .css('display','none');
      }


    }).slick({
      adaptiveHeight: true,
      infinite: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      //adaptiveHeight: true,

      responsive: [
        {

          breakpoint: 768,
          settings: {
            arrows: false
          }

        }
      ]
    })

    this.heroSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      let step = 100 / slick.slideCount;
      let calc = step * (nextSlide + 1);

      $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );

      
    });
  }

  mount2Item() {
    const $progressBar = $('.progress-2-item');

    this.hero2Item.on('init', function(event, slick ) {
      let calc = 100 / slick.slideCount;
      $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );

      if( slick.slideCount < 2) {
        $progressBar
        .css('display','none');
      }

    }).slick({
      infinite: true,
      autoplaySpeed: 4000,
      slidesToScroll: 1,
      autoplay: true,
      //adaptiveHeight: true,
      slidesToShow: 2,

      responsive: [
        {

          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            infinite: true,
            arrows: false
          }

        }
      ]
    })

    this.hero2Item.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      let step = 100 / slick.slideCount;
      let calc = step * (nextSlide + 1);
      $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
      
    });
  }

  mountHeroElements() {
    this.hero.forEach(el => {
      let {
        openInNewTab,
        link
      } = el.dataset

      if (link) {
        el.addEventListener('click', () => {
          let newWindow = window.open(link, openInNewTab === 'true' ? '_blank' : '_self');
          if (newWindow) newWindow.focus();
        });
      }
    })
  }

  render() {
    super.render();
    let that = this

    $(function(){
      that.bindEvents();
    });
  }
}

export class OLD_HeroComponent extends Component {

  get SELECTORS() {
    return {
      heroContainer: '.hero__container',
      heroVideo: '.hero__media.component-video',
      brigthcoveWrapper: '.brightcove-wrapper'
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.heroContainer = document.querySelector(this.SELECTORS.heroContainer);
  }


  stylizeOneMediaVideo() {
    let heroClasses = this.heroContainer.classList;
    if (heroClasses.contains('one-media') && heroClasses.contains('is-video')) {
      //if video exists
      let videoWrapper = this.heroContainer.querySelector(this.SELECTORS.brigthcoveWrapper);
      let heroVideo = this.heroContainer.querySelector(this.SELECTORS.heroVideo);
      if (videoWrapper != null && heroVideo != null) {
        let aspectRatioData = isMobile(MobileBreakpoint.Max767) ?
          videoWrapper.getAttribute('data-aspectratio-mobile') :
          videoWrapper.getAttribute('data-aspectratio');

        let aspectRatio = aspectRatioData.split(':').map(Number);
        //brightcove-loader calc
        let paddingBottom = aspectRatio[1] / aspectRatio[0] * 100;

        heroVideo.style.paddingBottom = paddingBottom + '%';
      }
    }
  }

  render() {
    super.render();
    this.stylizeOneMediaVideo();
  }
}
